import React, { useState, useEffect, useCallback } from 'react';
import { Save, Plus, AlertTriangle, FileText, Mail } from 'lucide-react';
import { getInviteContent, updateInviteContent, createInviteContent } from '../utils/inviteContentApi';
import { uploadFileToPublic } from '../utils/fileUpload';
import { useAuth } from '../contexts/AuthContext';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const InviteContent = () => {
  const { userSites } = useAuth();
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContent, setSelectedContent] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  // WYSIWYG Editor Configuration
  const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
  };

  const quillFormats = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'list', 'bullet', 'indent',
    'align', 'link', 'image'
  ];

  const [formData, setFormData] = useState({
    content_id: '',
    subject: '',
    banner: '',
    content: '',
    sub_content: '',
    updated_at: ''
  });

  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  // Ensure contents is always an array
  const safeContents = Array.isArray(contents) ? contents : [];

  const siteData = Array.isArray(userSites) ? (userSites.length > 0 ? userSites[0] : null) : userSites;
console.log('🔍 siteData:', siteData);
  // Fetch contents from API based on user's site ID
  const fetchContents = useCallback(async () => {
    console.log('🔍 fetchContents called with userSites111:', siteData.site_id);
    
    if (!siteData || !siteData.site_id) {
      console.warn('❌ No site ID available for user:', siteData);
      setLoading(false);
      return;
    } 

    

    setLoading(true);
    try {
      console.log('🚀 Fetching content for site_id:', siteData.site_id);
      const response = await getInviteContent({ site_id: siteData.site_id });
      
      //const response = Array.isArray(response2.data) ? (response2.data.length > 0 ? response2.data[0] : null) : response2.data || null;

      console.log('📡 API Response:', response);

      setApiResponse(response);
      
      if (response.success) {
        let contentData = response.data;
        
        // Handle different API response structures
        if (response.data && response.data.data) {
          contentData = response.data.data;
        } else if (response.data && response.data.contents) {
          contentData = response.data.contents;
        } else if (response.data && response.data.items) {
          contentData = response.data.items;
        } else if (response.data && response.data.results) {
          contentData = response.data.results;
        } else if (response.data && response.data.list) {
          contentData = response.data.list;
        } else if (response.data && response.data.records) {
          contentData = response.data.records;
        }
        
        console.log('📋 Processed content data:', contentData);
        
        if (Array.isArray(contentData)) {
          // Transform data to ensure content_id field exists (in case API returns 'id' instead)
          const transformedData = contentData.map(content => ({
            ...content,
            content_id: content.content_id || content.id || ''
          }));
          
          console.log('✅ Setting contents from API:', transformedData);
          setContents(transformedData);
          
          // Select content based on site ID
          const siteContent = transformedData.find(content => 
            content.site_id === siteData.site_id || 
            content.site_id === String(siteData.site_id)
          );
          
          if (siteContent) {
            console.log('🎯 Found content for site ID:', userSites.site_id, siteContent);
            setSelectedContent(siteContent);
            setFormData({
              content_id: siteContent.content_id || '',
              subject: siteContent.subject || '',
              banner: siteContent.banner || '',
              content: siteContent.content || '',
              sub_content: siteContent.sub_content || '',
              updated_at: siteContent.updated_at || ''
            });
          } else {
            console.log('⚠️ No content found for site ID:', userSites.site_id);
            setSelectedContent(null);
          }
        } else {
          console.warn('❌ API returned data but it\'s not an array:', contentData);
          setContents([]);
          setSelectedContent(null);
        }
      } else {
        console.warn('❌ API call failed:', response.error);
        setContents([]);
        setSelectedContent(null);
      }
    } catch (error) {
      console.warn('❌ API error:', error);
      // Fallback to mock data if API fails
      const mockData = [
        {
          content_id: 'CONT001',
          site_id: userSites.site_id,
          subject: 'Complete Your Survey',
          banner: '',
          content: '<p>Dear [FIRSTNAME],</p><p>We invite you to participate in our survey. Your feedback is valuable to us.</p><p>Please click the link below to access the survey:<br><a href="[LINK]">Survey Link</a></p><p>Thank you for your participation.</p>',
          sub_content: '<p>Best regards,<br>Survey Team</p>',
          updated_at: new Date().toISOString()
        }
      ];
      
      setApiResponse({ success: false, error: error.message });
      setContents(mockData);
      
      // Select mock data based on site ID
      const siteMockContent = mockData.find(content => 
        content.site_id === userSites.site_id || 
        content.site_id === String(userSites.site_id)
      );
      
      if (siteMockContent) {
        console.log('🎯 Found mock content for site ID:', userSites.site_id, siteMockContent);
        setSelectedContent(siteMockContent);
        setFormData({
          content_id: siteMockContent.content_id || '',
          subject: siteMockContent.subject || '',
          banner: siteMockContent.banner || '',
          content: siteMockContent.content || '',
          sub_content: siteMockContent.sub_content || '',
          updated_at: siteMockContent.updated_at || ''
        });
      } else {
        console.log('⚠️ No mock content found for site ID:', userSites.site_id);
        setSelectedContent(null);
      }
    } finally {
      setLoading(false);
    }
  }, [userSites]);

  // Fetch contents on component mount
  useEffect(() => {
    fetchContents();
  }, [fetchContents]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log('🚀 handleSubmit called, isCreateMode:', isCreateMode);
    console.log('📋 Form data:', formData);
    console.log('🎯 Selected content:', selectedContent);
    
    try {
      let response;
      if (isCreateMode) {
        // Add site_id to form data for creation
        const createData = {
          ...formData,
          site_id: userSites.site_id
        };
        console.log('📤 Creating content with data:', createData);
        response = await createInviteContent(createData);
      } else {
        if (!selectedContent || !selectedContent.content_id) {
          console.error('❌ No content template available to update');
          alert('No content template available to update. Please try creating a new content template or refresh the page.');
          return;
        }
        console.log('📤 Updating content with ID:', selectedContent.content_id);
        response = await updateInviteContent(selectedContent.content_id, formData);
      }

      console.log('📡 Submit response:', response);

      if (response.success) {
        console.log('✅ Content operation successful');
        
        if (isCreateMode) {
          // For create mode, show success and switch to edit mode with the new content
          alert('Content created successfully!');
          await fetchContents();
          setIsCreateMode(false);
        } else {
          // For update mode, just show success and keep the current data
          alert('Content updated successfully!');
          // Optionally refresh to get any server-side changes
          await fetchContents();
        }
      } else {
        console.error('❌ Content operation failed:', response.error);
        alert(`Failed to ${isCreateMode ? 'create' : 'update'} content: ` + (response.error || 'Unknown error'));
      }
    } catch (error) {
      console.error('❌ Submit error:', error);
      alert(`Error ${isCreateMode ? 'creating' : 'updating'} content: ` + error.message);
    }
  };

  const resetForm = () => {
    setFormData({
      content_id: '',
      subject: '',
      banner: '',
      content: '',
      sub_content: '',
      updated_at: ''
    });
  };

  const handleCreateMode = () => {
    setIsCreateMode(true);
    resetForm();
  };

  const handleUpdateMode = () => {
    setIsCreateMode(false);
    
    // Find content for current site ID (ensure content_id field exists)
    const siteContent = safeContents.find(content => {
      const contentWithId = {
        ...content,
        content_id: content.content_id || content.id || ''
      };
      return contentWithId.site_id === userSites.site_id || 
             contentWithId.site_id === String(userSites.site_id);
    });
    
    if (siteContent) {
      // Ensure content_id field exists
      const contentWithId = {
        ...siteContent,
        content_id: siteContent.content_id || siteContent.id || ''
      };
      
      console.log('🎯 Switching to update mode for site content:', contentWithId);
      setSelectedContent(contentWithId);
      setFormData({
        content_id: contentWithId.content_id || '',
        subject: contentWithId.subject || '',
        banner: contentWithId.banner || '',
        content: contentWithId.content || '',
        sub_content: contentWithId.sub_content || '',
        updated_at: contentWithId.updated_at || ''
      });
    } else {
      console.log('⚠️ No content found for site ID in update mode:', userSites.site_id);
      setSelectedContent(null);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Invite Content</h1>
          <p className="text-gray-600">
            {isCreateMode ? 'Create new email invitation content template.' : 'Update email invitation content templates.'}
          </p>
        </div>
        <div className="flex space-x-3 mt-4 sm:mt-0">
          {/**
          {!isCreateMode && (
            <button 
              onClick={handleCreateMode}
              className="btn-primary flex items-center space-x-2"
            >
              <Plus className="h-5 w-5" />
              <span>Create New</span>
            </button>
          )}
          */}
          {isCreateMode && (
            <button 
              onClick={handleUpdateMode}
              className="btn-secondary flex items-center space-x-2"
            >
              <span>Edit Existing</span>
            </button>
          )}
        </div>
      </div>

      {/* Update Form */}
      <div className="card">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <h3 className="text-lg font-medium text-gray-900">
            {isCreateMode ? 'Create Content Template' : 'Update Content Template'}
          </h3>
          <p className="text-sm text-gray-600">
            {isCreateMode 
              ? 'Fill in the details to create a new content template.'
              : selectedContent 
                ? `Editing: ${selectedContent.title}` 
                : 'Loading content template...'
            }
          </p>
          {userSites && userSites.site_id && (
            <p className="text-xs text-gray-500">Site ID: {userSites.site_id}</p>
          )}
        </div>
        
        <div className="p-6">
          {(selectedContent || isCreateMode) ? (
            <form onSubmit={handleSubmit} className="space-y-6">
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Subject *
                  </label>
                  <input
                    type="text"
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    placeholder="Enter email subject"
                    required
                  />
                </div>
                
                

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Banner Upload
                  </label>
                  <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                    <div className="space-y-1 text-center">
                      <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <div className="flex text-sm text-gray-600">
                        <label
                          htmlFor="banner-upload"
                          className="relative cursor-pointer bg-white rounded-md font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                        >
                          <span>{uploading ? 'Uploading...' : 'Upload a file'}</span>
                          <input
                            id="banner-upload"
                            name="banner-upload"
                            type="file"
                            className="sr-only"
                            accept="image/*"
                            disabled={uploading}
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                try {
                                  setUploading(true);
                                  setUploadError(null);
                                  console.log('📤 Starting file upload:', file.name);
                                  
                                  const filePath = await uploadFileToPublic(file, 'banners');
                                  console.log('✅ File uploaded successfully:', filePath);
                                  
                                  setFormData({...formData, banner: filePath});
                                } catch (error) {
                                  console.error('❌ File upload failed:', error);
                                  setUploadError(error.message);
                                  alert('Failed to upload file: ' + error.message);
                                } finally {
                                  setUploading(false);
                                }
                              }
                            }}
                          />
                        </label>
                        <p className="pl-1">or drag and drop</p>
                      </div>
                      <p className="text-xs text-gray-500">PNG, JPG, GIF up to 5MB</p>
                      {uploading && (
                        <p className="text-sm text-blue-600">Uploading banner...</p>
                      )}
                      {uploadError && (
                        <p className="text-sm text-red-600">Error: {uploadError}</p>
                      )}
                      {formData.banner && !uploading && (
                        <div className="mt-2">
                          <p className="text-sm text-green-600">✓ Banner uploaded successfully</p>
                          {formData.banner.startsWith('http') || formData.banner.startsWith('blob:') ? (
                            <img src={formData.banner} alt="Banner preview" className="mt-2 max-h-32 rounded" />
                          ) : (
                            <p className="text-xs text-gray-500 truncate">{formData.banner}</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Content
                  </label>
                  <div className="border border-gray-300 rounded-md">
                    <ReactQuill
                      value={formData.content}
                      onChange={(value) => setFormData({...formData, content: value})}
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder="Enter main content..."
                      style={{ minHeight: '200px' }}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Sub Content
                  </label>
                  <div className="border border-gray-300 rounded-md">
                    <ReactQuill
                      value={formData.sub_content}
                      onChange={(value) => setFormData({...formData, sub_content: value})}
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder="Enter sub content..."
                      style={{ minHeight: '150px' }}
                    />
                  </div>
                </div>
              
              {/* Submit Button */}
              <div className="flex justify-end pt-4">
                <button
                  type="submit"
                  className="btn-primary flex items-center space-x-2"
                >
                  <Save className="h-4 w-4" />
                  <span>{isCreateMode ? 'Create Content' : 'Update Content'}</span>
                </button>
              </div>
            </form>
          ) : (
            <div className="text-center py-8">
              <FileText className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-lg font-medium text-gray-500">No content template found</p>
              <p className="text-sm text-gray-400 mb-4">
                {userSites && userSites.site_id 
                  ? `No content template available for site ID: ${userSites.site_id}`
                  : 'Unable to load content template - no site ID available'
                }
              </p>
              <div className="space-y-2">
                <p className="text-sm text-gray-500">You can:</p>
                <button 
                  onClick={handleCreateMode}
                  className="btn-primary"
                >
                  Create New Content Template
                </button>
                <p className="text-xs text-gray-400">or refresh the page to retry loading</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteContent;
